export default {"src":"/_next/static/media/omnichannel-1.334d76f5.svg","height":121,"width":118,"blurWidth":0,"blurHeight":0};